import { AnalyticsSDK } from '@oneclick/analytics-sdk';

/**
 * Envía los eventos de analítica con @oneclick/analytics-sdk a la URL de ingesta del tenant.
 */
class AnalyticsService {
  constructor() {
    this.client = null;
    this.clientEndpoint = null;
    this.clientApiKey = null;
  }

  getClient(endpoint, apiKey) {
    if (!this.client || this.clientEndpoint !== endpoint || this.clientApiKey !== apiKey) {
      this.client = AnalyticsSDK.createClient({ endpoint, apiKey, timeout: 10000, retryAttempts: 3, retryDelay: 1000 });
      this.clientEndpoint = endpoint;
      this.clientApiKey = apiKey;
    }
    return this.client;
  }

  // Nunca lanza ni registra: CAM-16 descarta en silencio el evento fallido; `null` no, porque el Tutor IA lo usa para reintentar.
  async trackEvent(eventType, { endpoint, apiKey, tenant, user, context, payload }) {
    try {
      const event = AnalyticsSDK.createEvent(eventType)
        .withTenant(tenant)
        .withUser(user)
        .withContext(context)
        .withPayload(payload || {});

      return await event.send(this.getClient(endpoint, apiKey));
    } catch {
      return { success: false };
    }
  }
}

export default new AnalyticsService();
